import { render, staticRenderFns } from "./KousakuLoading.vue?vue&type=template&id=1ff36a65&scoped=true&"
import script from "./KousakuLoading.vue?vue&type=script&lang=js&"
export * from "./KousakuLoading.vue?vue&type=script&lang=js&"
import style0 from "./KousakuLoading.vue?vue&type=style&index=0&id=1ff36a65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff36a65",
  null
  
)

export default component.exports